import Reveal from '@/components/feature/Reveal';
import { accessPaths } from '@/mocks/home';

export default function AccessBoard() {
  return (
    <section id="status" className="scroll-mt-28 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <header className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs font-medium uppercase tracking-[0.3em] text-secondary-700">
                LIVE STATUS
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                实时可访问路径
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                每小时自动校验一次，下方为当前各线路的连通情况与最近一次检测时间。
              </p>
            </div>
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
              <i className="ri-radar-line text-sm" />
              最近校验：2 分钟前
            </div>
          </header>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-8 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
            <div className="hidden grid-cols-12 gap-4 border-b border-background-200/70 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-600 md:grid">
              <span className="col-span-4">线路</span>
              <span className="col-span-2">路径</span>
              <span className="col-span-2">状态</span>
              <span className="col-span-2">延迟</span>
              <span className="col-span-2">更新时间</span>
            </div>

            {accessPaths.map((row) => {
              const online = row.status === '可访问';
              return (
                <div
                  key={row.label}
                  className="grid grid-cols-1 gap-3 border-b border-background-200/60 px-5 py-4 last:border-b-0 md:grid-cols-12 md:items-center md:gap-4"
                >
                  <div className="col-span-4 flex items-center gap-3">
                    <span
                      className={`h-2 w-2 shrink-0 rounded-full ${
                        online ? 'bg-accent-500' : 'bg-secondary-400'
                      }`}
                    />
                    <span className="text-sm font-medium text-foreground-900">{row.label}</span>
                  </div>
                  <div className="col-span-2 text-sm text-foreground-600">{row.path}</div>
                  <div className="col-span-2">
                    <span
                      className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                        online
                          ? 'bg-accent-100 text-accent-900'
                          : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      {row.status}
                    </span>
                  </div>
                  <div className="col-span-2 text-sm text-foreground-600">{row.latency}</div>
                  <div className="col-span-2 text-sm text-foreground-500">{row.updated}</div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}